/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/catch-error-name */
/* eslint-disable prettier/prettier */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/no-object-as-default-parameter */
/* eslint-disable unicorn/no-this-assignment */
/* eslint-disable no-console */
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import Tooltip from './../Tooltip';
const NAME = 'CookiesModal';
const EVENT_KEY = `.lta.cookiesModal`;
const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;
const ESCAPE_KEY = 'Escape';
const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY}`;

class CookiesModal extends BaseComponent {
	constructor(element, globalCookiesBanner) {
		super(element);
		this.element = element;
		this.cookieBannerTab = globalCookiesBanner;
		this.openButton = SelectorEngine.findOne('#js-lta-cookie-modal-trigger');
		this.changeCookieSettings = SelectorEngine.findOne('#js-lta-cookie-anytime-modal-trigger');
		this.closeButton = SelectorEngine.findOne('.js-lta-cookies-modal-close');
		this.body = SelectorEngine.findOne('body');
		this.Cookies = undefined;
		this.withOverlay = element.classList.contains('with-overlay');
		this.cookiesBanner = SelectorEngine.findOne('#lta-cookies-banner');
		this.form = SelectorEngine.findOne('#lta-cookies-form');
		this.acceptBtn = SelectorEngine.findOne('#lta-cookies-button-accept');
		this.firstOpen = true;
		this.cookieDomain = location.hostname;
		this.enableBackdrop = false;
		// 3 month Duration?
		this.cookieDuration = 90;
		// third party cookies disabling for LTA play mobile
		this.thirpartyCookiesWrapper = SelectorEngine.findOne('.thirdPartyCookies');
		const isLTAPLAYMOBILE = document.querySelector('body').getAttribute('data-is-LTAPLAYMOBILE');
		this.isLTAPLAYMOBILE = isLTAPLAYMOBILE === 'True' || isLTAPLAYMOBILE === 'true';
		const thirdPartyCookiesAttribute = document.querySelector('body').getAttribute('data-is-ThirdPartyCookiesDisabled');
		this.disabledThirdPartyCookies = thirdPartyCookiesAttribute === 'True' || thirdPartyCookiesAttribute === 'true';

		if (this.form) {
			// eslint-disable-next-line promise/catch-or-return
			this.initCookiesLib().then(() => this.initModal());
		}
	}

	static get NAME() {
		return NAME;
	}

	initCookiesLib() {
		return import('js-cookie')
			.then(({ default: Cookies }) => {
				this.Cookies = Cookies;
				return this.Cookies;
			})
			.catch((error) => {
				console.log(error);
			});
	}

	initModal() {
		// Apply current cookies settings on the form
		if (this.Cookies.get('cookieprefs')) {
			const currentCookie = JSON.parse(this.Cookies.get('cookieprefs'));

			const setRadio = function (radio) {
				if (radio) radio.setAttribute('checked', 'true');
			};

			// Find current value for each cookie category and then update form
			let radio;
			if (currentCookie.func) {
				radio = SelectorEngine.findOne('#accept-func');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-func');
				setRadio(radio);
			}
			if (currentCookie.perf) {
				radio = SelectorEngine.findOne('#accept-perf');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-perf');
				setRadio(radio);
			}
			if (currentCookie.trgt) {
				radio = SelectorEngine.findOne('#accept-trgt');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-trgt');
				setRadio(radio);
			}
			if (currentCookie.thrd) {
				radio = SelectorEngine.findOne('#accept-thrd');
				setRadio(radio);
			} else {
				radio = SelectorEngine.findOne('#decline-thrd');
				setRadio(radio);
			}
		} else {
			// Default values rejected all

			const rejectedInputs = SelectorEngine.find('#decline-func, #decline-perf, #decline-trgt, #decline-thrd');
			for (const radioInput of rejectedInputs) {
				radioInput.setAttribute('checked', true);
			}
		}

		// On appear add stop-scrolling class on body? open-modal for grey overlay
		// Add accessibility tab trap functionality
		// On close trigger event to check if banner should reappear or not
		// Add event on cookies-change to track from location search plugin

		function appendEvergageScript() {
			const script = document.createElement('script');
			const environment = location.host.includes("ppe") ? 'lta_stage': 'lta_prod';
			script.src = `//cdn.evgnet.com/beacon/ltaoperations/${environment}/scripts/evergage.min.js`;
			script.type = 'text/javascript';
			script.async = true;
			document.head.appendChild(script);
		}

		function gtag() { dataLayer.push(arguments); }

		const _self = this;
		const setCookie = function (type, value, allowThirdPartyCookies, cookie = { func: true, perf: true, trgt: true, thrd: true }) {
			_self.Cookies.set(type, value, { expires: _self.cookieDuration });

			if(allowThirdPartyCookies === true) {

				try {
					gtag('consent', 'update', {
						ad_user_data: 'granted',
						ad_personalization: 'granted',
						ad_storage: 'granted',
						analytics_storage: 'granted',					
					});
				} catch (e) {
					console.log(e.message);
				}

				try {
					// More data send, for the GTM events to handle
					window.dataLayer.push({
						event: 'cookie-consent',
						funcCategory: cookie.func,
						perfCategory: cookie.perf,
						trgtCategory: allowThirdPartyCookies,
						thrdCategory: allowThirdPartyCookies,
						ad_storage: 'granted',
						ad_user_data: 'granted',
						ad_personalization: 'granted',
						analytics_storage: 'granted',
						clicked: 'Manage settings'
					});
					// As some of the required events are not being pushed with above event. Initialization the init event again. Nedd to find a better solution.
					window.dataLayer.push({ 'event': 'gtm.init' });
				} catch (e) {
					console.log(e.message);
				}
			} else {
				try {
					// More data send, for the GTM events to handle
					window.dataLayer.push({
						event: 'cookie-consent',
						funcCategory: cookie.func,
						perfCategory: cookie.perf,
						trgtCategory: allowThirdPartyCookies,
						thrdCategory: allowThirdPartyCookies,
					});
					window.dataLayer.push({ 'event': 'gtm.init' });
				} catch (e) {
					console.log(e.message);
				}
			}

			if(cookie.func === true ) { 
				appendEvergageScript();
			}
		};

		const setCookies = function (type, value, allowThirdPartyCookies) {
			_self.Cookies.set(type, value, { expires: _self.cookieDuration });

			try {
				gtag('consent', 'update', {
					ad_user_data: allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					ad_personalization: allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					ad_storage: allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					analytics_storage: allowThirdPartyCookies.perf === true ? 'granted' : 'denied'				
				});
			} catch (e) {
				console.log(e.message);
			}

			try {
				// More data send, for the GTM events to handle
				window.dataLayer.push({
					event: 'cookie-consent',
					funcCategory: allowThirdPartyCookies.func,
					perfCategory: allowThirdPartyCookies.perf,
					trgtCategory: allowThirdPartyCookies.trgt,
					thrdCategory: allowThirdPartyCookies.thrd,
					ad_storage: allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					ad_user_data: allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					ad_personalization:allowThirdPartyCookies.thrd === true ? 'granted' : 'denied',
					analytics_storage: allowThirdPartyCookies.perf === true ? 'granted' : 'denied',
					clicked: 'Manage settings'
				});
				window.dataLayer.push({ 'event': 'gtm.init'});
			} catch (e) {
				console.log(e.message);
			}

			if(allowThirdPartyCookies.func === true ) { 
				appendEvergageScript();
			}
		};

		if (this.openButton) {
			EventHandler.on(this.openButton, 'click', () => {
				this.cookieBannerTab._disableFocus(); //remove tab focus from the cookie banner
				this.toggleBodyClass();
				this.enableBackdrop = true;
				this.openModal();
			});
		}

		if (this.changeCookieSettings) {
			EventHandler.on(this.changeCookieSettings, 'click', () => {
				this.cookieBannerTab._disableFocus(); //remove tab focus from the cookie banner
				this.openModal();
			});
		}

		if (this.closeButton) {
			EventHandler.on(this.closeButton, 'click', () => {
				this.closeModal();
			});
		}

		const acceptedValue = {
			func: true,
			perf: true,		
			// third party cookies disabling for LTA play mobile
			trgt: this.isLTAPLAYMOBILE ? !(this.disabledThirdPartyCookies) : true,
			thrd: this.isLTAPLAYMOBILE ? !(this.disabledThirdPartyCookies) : true
		};
		const acceptedCookie = JSON.stringify(acceptedValue);

		EventHandler.on(this.acceptBtn, 'click', () => {
			this.Cookies.set('cookieprefs', acceptedCookie, { expires: this.cookieDuration });
			if (!acceptedValue.func || !acceptedValue.perf || !acceptedValue.trgt) {
				if (this.isLTAPLAYMOBILE && this.disabledThirdPartyCookies) {
					setCookie('consent', false, !this.disabledThirdPartyCookies);
				} else if (this.isLTAPLAYMOBILE && !this.disabledThirdPartyCookies) {
					setCookie('consent', false, this.disabledThirdPartyCookies);
				}
			} else {
				setCookie('consent', true, true);
			}
			this.geolocationTrigger();
			EventHandler.off(document, EVENT_FOCUSIN);
			EventHandler.off(document, EVENT_KEYDOWN_DISMISS);
		});

		EventHandler.on(this.form, 'submit', (event) => {
			event.preventDefault();
			const formData = new FormData(this.form);

			if (formData) {
				const newCookie = {
					func: formData.get('func') === 'true',
					perf: formData.get('perf') === 'true',
					trgt: formData.get('thrd') === 'true', 
					thrd: formData.get('thrd') === 'true'
				};

				this.Cookies.set('cookieprefs', JSON.stringify(newCookie), { expires: this.cookieDuration });

				// If one of the categories is set to false consent = false
				if (!newCookie.func || !newCookie.perf || !newCookie.trgt) {
					setCookies('consent', false, newCookie);
				} else {
					setCookie('consent', true, true);
				}

				// window.scrollTo(0, 0);
				// this.cookiesMessage.classList.add('is-visible');

				// Remove class to restart animation on change
				// EventHandler.one(this.cookiesMessage, 'animationend', (cookieMessageEvent) => {
				// 	cookieMessageEvent.target.classList.remove('is-visible');
				// });

				this.geolocationTrigger();
			}
			EventHandler.off(document, EVENT_FOCUSIN);
			EventHandler.off(document, EVENT_KEYDOWN_DISMISS);
		});
	}

	openModal() {
		if (this.withOverlay) this.toggleBodyClass();
		this.cookiesBanner.classList.remove('is-visible');
		this._element.classList.add('is-visible');

		// third party cookies disabling for LTA play mobile
		if (this.disabledThirdPartyCookies && this.isLTAPLAYMOBILE) {
			this.thirpartyCookiesWrapper.classList.add('u-hidden');
		} else {
			this.thirpartyCookiesWrapper.classList.remove('u-hidden');
		}

		if (this.firstOpen) {
			const tooltip = this.form.querySelectorAll('.js-lta-tooltip');
			if (tooltip) {
				tooltip.forEach((e) => {
					Tooltip.getOrCreateInstance(e);
				});
			}
			this.firstOpen = false;
		}

		this._enforceFocus(); // guard against infinite focus loop
		this._setEscapeEvent();
	}

	closeModal() {
		if (this.withOverlay) this.toggleBodyClass();
		this.cookiesBanner.classList.add('is-visible');
		if(this.enableBackdrop) this.toggleBodyClass();
		this._element.classList.remove('is-visible');
		EventHandler.off(document, EVENT_FOCUSIN);
		EventHandler.off(document, EVENT_KEYDOWN_DISMISS);
		this.cookieBannerTab._enforceFocus(); // enable the tab focus back to cookie banner
	}

	_enforceFocus() {
		EventHandler.off(document, EVENT_FOCUSIN); // guard against infinite focus loop
		EventHandler.on(document, EVENT_FOCUSIN, (event) => {
			if (document !== event.target && this.element !== event.target && !this.element.contains(event.target)) {
				this.closeButton.focus();
			}
		});
	}

	_setEscapeEvent() {
		EventHandler.on(document, EVENT_KEYDOWN_DISMISS, (event) => {
			if (event.key === ESCAPE_KEY) {
				event.preventDefault();
				this.closeModal();
			}
		});
	}

	geolocationTrigger() {
		if (this.withOverlay) this.toggleBodyClass();
		this._element.classList.remove('is-visible');
		const event = new CustomEvent('cookiesAcceptance');
		window.dispatchEvent(event);
	}

	toggleBodyClass() {
		this.body.classList.toggle('cookies-modal-open');
	}
}

export default CookiesModal;
